import React, { useState } from 'react';
import { TextareaAutosize } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postPlannerTodos } from '../../../../sevices/apiPlannerTodos';
import toast from 'react-hot-toast';

/**
 * Component for adding a new task that matches the design of existing task items
 */
const AddTaskItem = ({ handleKeyDown }) => {
  const [taskText, setTaskText] = useState('');
  const queryClient = useQueryClient();
  
  // Create todo mutation
  const { mutate: createTodo } = useMutation({
    mutationFn: postPlannerTodos,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['todos'] });
      toast.success('Task created successfully');
      setTaskText(''); // Clear input on success
    },
    onError: (error) => {
      toast.error(error?.message || 'Failed to create task');
    }
  });
  
  const handleAddTask = () => {
    if (taskText.trim()) {
      const newTask = {
        title: taskText.trim(),
        after_todo: null,
        source_id: null,
        source_type: null,
        due_date: null,
        completed_at: null,
      };
      
      createTodo(newTask);
    }
  };

  return (
    <div className={` new-task-item `}>
      <div className="task-drag-handle"></div>
      <div className="task-content">
        <TextareaAutosize
          className="task-text-edit add-task-input"
          placeholder="Add a title"
          value={taskText}
          onChange={(e) => setTaskText(e.target.value)}
          onBlur={() => {
            if (taskText.trim()) {
              handleAddTask();
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              handleAddTask();
            } else {
              handleKeyDown && handleKeyDown(e);
            }
          }}
          minRows={1}
          maxRows={5}
          // spellCheck={false}
        />
      </div>
    </div>
  );
};

export default AddTaskItem; 